import { BlockUIService } from './block-ui.service';

/** Public handle assigned to @BlockUI-decorated properties (matches ng-block-ui's NgBlockUI). */
export interface NgBlockUI {
  start(message?: string): void;
  stop(): void;
}

/**
 * Module-level singleton reference to the service. Set by BlockUIModule.forRoot()
 * (constructor injection) so the property decorator can reach the service without DI.
 * Mirrors how ng-block-ui wired its global instance.
 */
let blockUIServiceRef: BlockUIService | null = null;
export function setBlockUIServiceRef(svc: BlockUIService): void {
  blockUIServiceRef = svc;
}

class BlockUIHandle implements NgBlockUI {
  constructor(private readonly name: string) {}
  start(message?: string): void {
    blockUIServiceRef?.start(this.name, message);
  }
  stop(): void {
    blockUIServiceRef?.stop(this.name);
  }
}

/**
 * Property decorator: @BlockUI('block-name') blockUI: NgBlockUI;
 * Assigns a handle bound to the named block. Drop-in for ng-block-ui's @BlockUI.
 */
export const DEFAULT_BLOCK_UI = '__default_block_ui__';
export function BlockUI(name: string = DEFAULT_BLOCK_UI): PropertyDecorator {
  return (target: object, propertyKey: string | symbol): void => {
    const handle = new BlockUIHandle(name);
    Object.defineProperty(target, propertyKey, {
      get: () => handle,
      enumerable: true,
      configurable: true,
    });
  };
}
